import { Pack } from '@alienheadwars/football-card-manager-model';
// import standard MUI components needed for Card content
import { Card } from '@mui/material'; // Keep Card for avatar styling if needed
import React, { useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { localise, localiseAndReplace } from '../../../../locale/locale';
import { ButtonComponent } from '../../../base/button/Button';
import { HelpOverlay } from '../../../base/tutorial/helpOverlay/HelpOverlay';
import { TeamContext } from '../../TeamContext';

// import the final Animated components from MotionMui.tsx
// We also need the specific item variant now
import {
  AnimatedCard,
  AnimatedCardActions,
  AnimatedCardHeader,
  AnimatedStack,
  fadeInSlideUpVariants, // import the item variant
} from '../../../MotionMui/MotionMui'; // Adjust path as needed

export const NewPackListPage = () => {
  const teamContext = useContext(TeamContext);
  const history = useHistory();
  const packs = teamContext.getUnopenedPacks(); // Get packs once

  useEffect(() => {
    // Redirect if packs array becomes empty after initial load
    if (packs.length === 0) {
      history.goBack();
    }
  }, [packs.length, history]);

  // Use AnimatedStack - it applies staggering defaults automatically
  return (
    <AnimatedStack spacing={2}>
      {packs.map((pack) => (
        <HelpOverlay
          tutorialId="newPack"
          helpText={localise('tutorial.newPack')}
          blockSkip={true}
        >
          {/* NewPackCardContent renders the inner parts */}
          <NewPackCardContent
            pack={pack}
            openFunction={() => {
              history.push(
                `${teamContext.getBaseUrl()}/news/packs/${pack.uid}`
              );
            }}
          />
        </HelpOverlay>
      ))}
    </AnimatedStack>
  );
};

// Renamed to NewPackCardContent as it only provides the inner parts
// It uses the Animated components for header/actions
const NewPackCardContent = (props: {
  pack: Pack;
  openFunction: () => void;
}) => {
  return (
    <AnimatedCard variants={fadeInSlideUpVariants} key={props.pack.id}>
      <AnimatedCardHeader
        avatar={
          <Card sx={{ borderRadius: '5%', overflow: 'hidden' }}>
            <img
              src={`/images/${props.pack.art[0]?.image}.png`}
              alt={props.pack.id}
              style={{
                width: '20vmin', // Consider theme spacing
                height: 'auto', // Maintain aspect ratio
                display: 'block',
                objectFit: 'contain',
              }}
              onError={(e) => (e.currentTarget.style.display = 'none')}
            />
          </Card>
        }
        title={localiseAndReplace({
          id: `pack.${props.pack.id}.name`,
          replacements: props.pack.params,
        })}
        subheader={localiseAndReplace({
          id: `pack.${props.pack.id}.description`,
          replacements: props.pack.params,
        })}
      />
      <AnimatedCardActions>
        <ButtonComponent size="small" onClick={props.openFunction}>
          Open now
        </ButtonComponent>
      </AnimatedCardActions>
    </AnimatedCard>
  );
};
